<template lang="pug">
.teacher-list
  //- サイドメニュー部
  side-menu.teacher-list__side-menu(
    :userRole='userRole',
    :currentLink='currentLink',
    :linkEvent='sideMenuLinkEvent',
    :logoutEvent='logoutEvent'
  )
    template(#separateText)
      slot(name='sideMenuSeparateText')
    template(#logoutText)
      slot(name='logoutText')
  //- コンテンツ表示部
  .teacher-list__content
    breadcrumb-list.teacher-list__content__breadcrumb(
      v-if='isAdmin',
      :breadcrumbs='breadcrumbs',
      :buttonEvent='openRegisterModal'
    )
      template(#buttonLabel)
        slot(name='breadcrumbButtonLabel')
    breadcrumb-list.teacher-list__content__breadcrumb(v-else, :breadcrumbs='breadcrumbs')
    .teacher-list__content__body
      .teacher-list__content__body__heading
        tab-heading.teacher-list__content__body__heading__tab(:isActive='true') {{ tabSetting.TEACHER.text }}
        tab-heading.teacher-list__content__body__heading__tab(
          :isActive='false',
          @click='tabHeadingEvent(tabSetting.STUDENT.value)'
        ) {{ tabSetting.STUDENT.text }}
      .teacher-list__content__body__main
        .teacher-list__content__body__main__action
          search-teacher.teacher-list__content__body__main__action__search(
            :userRole='userRole',
            :fullName='fullName',
            :academyName='academyName',
            :branchName='branchName',
            :authority='authority',
            :fullNamePlaceholder='fullNamePlaceholder',
            :academyNamePlaceholder='academyNamePlaceholder',
            :branchNamePlaceholder='branchNamePlaceholder',
            :authorityPlaceholder='authorityPlaceholder',
            :fullNameChangeEvent='setFullName',
            :academyNameChangeEvent='setAcademyName',
            :branchNameChangeEvent='setBranchName',
            :authorityChangeEvent='setAuthority',
            :searchEvent='searchEvent'
          )
            template(#searchButtonText)
              slot(name='searchButtonText')
          .teacher-list__content__body__main__action__button
            button-icon-circle.teacher-list__content__body__main__action__button__icon(
              type='qr',
              @click='qrOutputEvent'
            )
              slot(name='qrOutputIconLabel')
            button-icon-circle.teacher-list__content__body__main__action__button__icon(
              type='download',
              @click='downloadEvent'
            )
              slot(name='downloadIconLabel')
            button-upload.teacher-list__content__body__main__action__button__icon(
              v-if='isAdmin',
              :uploadEvent='uploadEvent'
            )
              template(#iconLabel)
                slot(name='uploadIconLabel')
        teacher-list-table.teacher-list__content__body__main__table(
          v-if='sort && teacherDatas',
          :userRole='userRole',
          :checkedAll='checkedAll',
          :headerCheckboxChangeEvent='setCheckedAll',
          :sort='sort',
          :sortChangeEvent='changeSort',
          :teacherDatas='teacherDatas',
          :checkedTeacherUserIds='checkedTeacherUserIds',
          :checkboxChangeEvent='setCheckedTeacherUserIds',
          :deleteEvent='deleteEvent',
          :editEvent='openEditModal'
        )
          template(#userNameHeader)
            slot(name='userNameHeader')
          template(#bcbtCodeHeader)
            slot(name='bcbtCodeHeader')
          template(#academyNameHeader)
            slot(name='academyNameHeader')
          template(#branchNameHeader)
            slot(name='branchNameHeader')
          template(#roleNameHeader)
            slot(name='roleNameHeader')
          template(#editHeader)
            slot(name='editHeader')
          template(#popupRemoveText)
            slot(name='popupRemoveText')
          template(#popupEditText)
            slot(name='popupEditText')
        .teacher-list__content__body__main__footer
          button-pagination.teacher-list__content__body__main__footer__pager(
            :status='pagenationStatus',
            @click='pagenationEvent'
          )
  //- モーダル部
  modal-teacher-edit.teacher-list__modal(
    v-if='teacherEditData',
    ref='modalTeacherEdit',
    :userRole='userRole',
    :title='modalTitle',
    :userNamePlaceholder='modalUserNamePlaceholder',
    :userBcbtCodePlaceholder='modalUserBcbtCodePlaceholder',
    :passwordPlaceholder='modalPasswordPlaceholder',
    :passwordConfirmPlaceholder='modalPasswordConfirmPlaceholder',
    :teacherEditData='teacherEditData',
    :academySelectOptions='modalAcademySelectOptions',
    :academyChangeEvent='modalAcademyChangeEvent',
    :branchSelectOptions='modalBranchSelectOptions',
    :keepButtonEvent='modalKeepButtonEvent',
    :errorMessages='modalErrorMessages'
  )
    template(#roleNameLabel)
      slot(name='modalRoleNameLabel')
    template(#academyNameLabel)
      slot(name='modalAcademyNameLabel')
    template(#academyNameDisabledLabel)
      slot(name='modalAcademyNameDisabledLabel')
    template(#branchNameLabel)
      slot(name='modalBranchNameLabel')
    template(#branchNameDisabledLabel)
      slot(name='modalBranchNameDisabledLabel')
    template(#userNameLabel)
      slot(name='modalUserNameLabel')
    template(#userBcbtCodeLabel)
      slot(name='modalUserBcbtCodeLabel')
    template(#passwordLabel)
      slot(name='modalPasswordLabel')
    template(#passwordLabelAnnotation)
      slot(name='modalPasswordLabelAnnotation')
    template(#passwordConfirmLabel)
      slot(name='modalPasswordConfirmLabel')
    template(#passwordConfirmLabelAnnotation)
      slot(name='modalPasswordConfirmLabelAnnotation')
    template(#keepText)
      slot(name='modalKeepText')
</template>

<script lang="ts">
import { Component, Prop, Vue, Ref } from 'vue-property-decorator'
import SideMenu from '@/components/organisms/manager/SideMenu.vue'
import BreadcrumbList from '@/components/organisms/manager/BreadcrumbList.vue'
import TabHeading from '@/components/molecules/manager/TabHeading.vue'
import SearchTeacher from '@/components/organisms/manager/SearchTeacher.vue'
import ButtonIconCircle from '@/components/molecules/manager/ButtonIconCircle.vue'
import ButtonUpload from '@/components/molecules/manager/ButtonUpload.vue'
import TeacherListTable from '@/components/organisms/manager/TeacherListTable.vue'
import ButtonPagination from '@/components/molecules/manager/ButtonPagination.vue'
import ModalTeacherEdit from '@/components/organisms/manager/ModalTeacherEdit.vue'
import { breadcrumbType } from '@/models/breadcrumbModel'
import { TeacherListType, TeacherListSortType, TeacherEditType } from '@/models/teacherListModel'
import { InputItem } from '@/models/inputItem'
import { PaginationStatus } from '@/models/paginationModel'
import { LinkSetting } from '@/const/SideMenuSettings'
import { UserRoles } from '@/const/UserRoles'
import { TeacherStudentTabSetting } from '@/const/TabLinkSettings'
import { SortSetting } from '@/const/SortSettings'

/**
 * ユーザー管理画面（先生・講師）
 */
@Component({
  components: {
    SideMenu,
    BreadcrumbList,
    TabHeading,
    SearchTeacher,
    ButtonIconCircle,
    ButtonUpload,
    TeacherListTable,
    ButtonPagination,
    ModalTeacherEdit,
  },
})
export default class TeacherList extends Vue {
  // ユーザ権限
  @Prop()
  userRole!: UserRoles

  // このページのリンク設定
  @Prop()
  currentLink!: LinkSetting

  // サイドメニューリンク押下時のイベント
  @Prop()
  sideMenuLinkEvent!: Function

  // ログアウトボタン押下時のイベント
  @Prop()
  logoutEvent!: Function

  // パンくず一覧情報
  @Prop()
  breadcrumbs!: breadcrumbType[]

  // 新規登録用の情報設定イベント（システム管理者画面のみ）
  @Prop()
  setRegisterDataEvent?: Function

  // 見出しタブクリック時のイベント
  @Prop()
  tabHeadingEvent!: Function

  // 氏名プレースホルダー
  @Prop()
  fullNamePlaceholder!: string

  // 塾名プレースホルダー（ユーザ権限がシステム管理者の場合のみ設定）
  @Prop()
  academyNamePlaceholder?: string

  // 教室名プレースホルダー(ユーザ権限がシステム管理者、塾管理者の場合のみ設定)
  @Prop()
  branchNamePlaceholder?: string

  // 権限プレースホルダー
  @Prop()
  authorityPlaceholder!: string

  // 検索イベント
  @Prop()
  searchEvent!: Function

  // QR出力ボタン押下時イベント
  @Prop()
  qrOutputEvent!: Function

  // ダウンロードボタン押下時イベント
  @Prop()
  downloadEvent!: Function

  // アップロードボタン押下時イベント（システム管理者画面のみ）
  @Prop()
  uploadEvent?: Function

  // ソート値（項目毎の昇順フラグ）
  @Prop()
  sort!: TeacherListSortType

  // 先生一覧情報
  @Prop()
  teacherDatas!: TeacherListType[]

  // 削除ボタン押下時イベント（システム管理者画面のみ）
  @Prop()
  deleteEvent?: Function

  // 編集用の情報設定イベント
  @Prop()
  setEditDataEvent!: Function

  // ページネーションの状態
  @Prop()
  pagenationStatus!: PaginationStatus

  // ページネーションイベント
  @Prop()
  pagenationEvent!: Function

  // モーダルのタイトル
  @Prop()
  modalTitle!: string

  // モーダルの氏名プレースホルダー（システム管理者画面のみ）
  @Prop()
  modalUserNamePlaceholder?: string

  // モーダルのBCBTコードプレースホルダー（システム管理者画面のみ）
  @Prop()
  modalUserBcbtCodePlaceholder?: string

  // モーダルのパスワードプレースホルダー
  @Prop()
  modalPasswordPlaceholder!: string

  // モーダルのパスワード（確認）プレースホルダー
  @Prop()
  modalPasswordConfirmPlaceholder!: string

  // 編集対象のユーザー（先生・講師）情報
  @Prop()
  teacherEditData!: TeacherEditType

  // モーダルの塾名選択プルダウンのオプション（システム管理者画面のみ）
  @Prop()
  modalAcademySelectOptions?: InputItem[]

  // モーダルの塾名変更時イベント（システム管理者のみ）
  @Prop()
  modalAcademyChangeEvent?: Function

  // モーダルの教室名選択プルダウンのオプション（システム管理者、塾管理者画面のみ）
  @Prop()
  modalBranchSelectOptions?: InputItem[]

  // モーダルの保存ボタン押下時イベント
  @Prop()
  modalKeepButtonEvent!: Function

  // モーダルに表示するエラーメッセージ
  @Prop()
  modalErrorMessages!: string[]

  // モーダルref
  @Ref()
  modalTeacherEdit!: ModalTeacherEdit

  // === 選択値を保持する変数群
  // 氏名
  public fullName = ''
  // 塾名
  public academyName = ''
  // 教室名
  public branchName = ''
  // 権限
  public authority = ''
  // 全チェックフラグ
  public checkedAll = false
  // チェックされた先生ユーザーID
  public checkedTeacherUserIds: number[] = []

  // === 選択値をセットする関数群
  // 氏名をセット
  private setFullName(value: string) {
    this.fullName = value
  }
  // 塾名をセット
  private setAcademyName(value: string) {
    this.academyName = value
  }
  // 教室名をセット
  private setBranchName(value: string) {
    this.branchName = value
  }
  // 権限をセット
  private setAuthority(value: string) {
    this.authority = value
  }
  // 全チェックフラグをセット
  private setCheckedAll(value: boolean) {
    this.checkedAll = value
  }
  // チェックされた先生ユーザーIDをセット
  private setCheckedTeacherUserIds(value: number[]) {
    this.checkedTeacherUserIds = value
  }

  // ソート値を変更
  private changeSort(sortSetting: SortSetting, sortTarget: string) {
    const sort = this.sort
    sort[sortTarget] = sortSetting
    this.$emit('sort-changed', sort)
  }

  // 新規登録モーダルを開く
  private async openRegisterModal() {
    if (!this.setRegisterDataEvent) {
      return
    }

    await this.setRegisterDataEvent()
    if (this.teacherEditData) {
      this.modalTeacherEdit.show()
    }
  }

  // 編集モーダルを開く
  private async openEditModal(id: number) {
    await this.setEditDataEvent(id)
    if (this.teacherEditData) {
      this.modalTeacherEdit.show()
    }
  }

  // 見出しタブリンクの表示設定
  private get tabSetting(): TeacherStudentTabSetting {
    return TeacherStudentTabSetting
  }

  // システム管理者であるか
  private get isAdmin(): boolean {
    return this.userRole === UserRoles.ADMIN
  }
}
</script>

<style lang="stylus" scoped>
.teacher-list
  display flex
  width 100%
  height 100%

  &__content
    width 100%
    height 100%
    display flex
    flex-direction column
    padding 40px
    gap 20px
    overflow-y auto

    &__body
      display flex
      flex-direction column

      &__heading
        display flex
        height 43px

      &__main
        z-index 1
        width 100%
        min-height 500px
        display flex
        flex-direction column
        border-radius 0px 15px 15px 15px
        background var(--color-manager-list__background)
        box-shadow 0px 3px 5px 0px var(--color-manager-list__shadow)

        &__action
          display flex
          justify-content space-between
          align-items center
          padding 12px 20px

          &__search
            padding 7px 5px

          &__button
            display flex
            gap 12px

            &__icon
              width 32px
              height 32px

        &__footer
          display flex
          justify-content flex-end
          align-items center
          padding 20px 30px
          margin-top auto
</style>
